export const SHOP = {
  name: "Utsav Flowers",
  established: 1999,
  phoneDisplay: "+91 99577 29111",
  phoneAlt: "94350 31126 · 94350 31265",
  phoneLink: "+919957729111",
  whatsapp: "919957729111",
  address: "Kusum Hotel Complex, Talkie House Road, Jalukpara, Babulal Poddar Path, Dibrugarh, Assam 786001",
  hours: "Open daily · 8:00 AM – 9:00 PM",
  upiId: "paytmqr6I5wan@ptys",
  upiName: "Utsav Flowers (Paytm)",
};

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const formatINR = (n) =>
  "₹" + Number(n).toLocaleString("en-IN", { maximumFractionDigits: 0 });
